<template>
    <div>
        <v-card>
            <v-card-title class="header">
                <span class="headline">GENERATE PAYMENT PLAN</span>
            </v-card-title>
            <v-card-text class="content">
              <v-row
                class="mb-12"
                justify="space-between"
              >
                <v-col class="text-center">
                  <span class="subheading f-s-25 font-weight-light mr-1">$</span>
                  <span
                    class="display-3 font-weight-light"
                    v-text="loanAmountRange.approvedAmount"
                  ></span>
                </v-col>
              </v-row>
                <v-slider
                        v-model="loanAmountRange.approvedAmount"
                        :min="loanAmountRange.minimumLoanAmount"
                        :max="loanAmountRange.maximumLoanAmount"
                        color="orange darken-3"
                        class="align-center"
                        step="25"
                        always-dirty
                        hide-details
                >
                  <template v-slot:prepend>
                    <v-icon
                      @click="decrement"
                    >
                      mdi-minus
                    </v-icon>
                  </template>

                  <template v-slot:append>
                    <v-icon
                      @click="increment"
                    >
                      mdi-plus
                    </v-icon>
                  </template>
                </v-slider>
            </v-card-text>
            <v-card-text v-if="loanAmountRange.approvedAmount !== loanAmountRange.maximumLoanAmount">
                <v-container
                        fluid
                        class="reason-container">
                    <v-layout>
                        <v-flex lg12>
                            <span>This customer qualifies for {{loanAmountRange.maximumLoanAmount}}
                               . Do you really want to offer {{loanAmountRange.approvedAmount}}  only?</span>
                            <v-radio-group
                                    v-model="optionCode"
                                    column
                                    hide-details>
                                <v-radio
                                        :label="`No, the customer wants the full amount ${loanAmountRange.maximumLoanAmount}`"
                                        value="101"
                                        color="primary"
                                ></v-radio>
                                <v-radio
                                        :label="`Yes, the customer only wants ${loanAmountRange.approvedAmount}`"
                                        value="102"
                                        color="primary"
                                ></v-radio>
                            </v-radio-group>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-card-text>
            <v-card-actions class="footer">
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="hideDialog">Close</v-btn>
                <v-btn color="blue darken-1" text @click="save">Save</v-btn>
            </v-card-actions>
        </v-card>
    </div>
</template>

<script>
import { OriginationApi } from '@/api/pandaria'
import { Tool, DataType, Popup } from '@/util/index'
const tool = new Tool()
const popup = new Popup()
export default {
  name: 'application-detail-generate-payment-plan-dialog',
  props: {
    loan: Object,
    dataSource: Object,
    slaveLoanId: Number
  },
  data () {
    return {
      optionCode: '101',
      loanAmountRange: {
        approvedAmount: 0,
        minimumLoanAmount: 0,
        maximumLoanAmount: 0
      }
    }
  },
  computed: {
    loanAmount () {
      return this.dataSource.sectionData.loanAmount
    },
    loanId () {
      return this.loan.id
    }
  },
  watch: {
    loanAmount: {
      handler: function (newVal) {
        this.initGeneratePaymentPlan(newVal)
      },
      immediate: true
    }
  },
  mounted () {
    this.$eventBus.$on('loanAmountUpdated', target => {
      this.initGeneratePaymentPlan(target.loanAmount)
    })
  },
  methods: {
    hideDialog () {
      this.$emit('hideDialog')
    },
    decrement () {
      this.loanAmountRange.approvedAmount -= 25
    },
    increment () {
      this.loanAmountRange.approvedAmount += 25
    },
    initGeneratePaymentPlan (loanAmount) {
      if (this.loan.loanType === DataType.LoanTypeEnum.MULTIPLE_ADVANCE_LOAN.value) {
        loanAmount = loanAmount / 2
      }
      this.loanAmountRange.approvedAmount = this.dataSource.sectionData.approvedAmount
      if (Object.prototype.hasOwnProperty.call(this.dataSource, 'programArray')) {
        const program = this.dataSource.programArray.find(
          program => program.id === this.dataSource.sectionData.program
        )

        if (tool.isNotEmpty(program)) {
          this.loanAmountRange.minimumLoanAmount = program.minimumLoanAmount
          this.loanAmountRange.maximumLoanAmount = program.maximumLoanAmount
          if (loanAmount < this.loanAmountRange.maximumLoanAmount ||
            this.loan.category === DataType.CategoryEnum.RETURNING_CUSTOMER.value) {
            this.loanAmountRange.maximumLoanAmount = loanAmount
          }
        }
      }
    },
    save () {
      const $this = this
      OriginationApi.getLoanSignData(this.loanId, function (result) {
        const signStatus = tool.isNotEmpty(result) ? result.signStatus : null
        if ((signStatus === DataType.SignStatusEnum.SIGNED.value)) {
          popup.popupForInfo('This change will void the previous loan agreement. Are you sure continue?', {
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
          }, function () {
            $this.saveAction()
          })
        } else {
          $this.saveAction()
        }
      }, function (result) {
        $this.saveAction()
      })
    },
    saveAction () {
      let approvedAmount = this.loanAmountRange.approvedAmount
      const maximumLoanAmount = this.loanAmountRange.maximumLoanAmount
      const tempLoanAmountRange = { ...this.loanAmountRange }
      const loanId = this.loan.id
      const transferAmount = this.loan.transferredAmount || 0
      const $this = this
      if (approvedAmount < maximumLoanAmount) {
        if ($this.optionCode === '101') {
          approvedAmount = maximumLoanAmount
        }
      }
      const updateSectionData = {
        loanId: loanId,
        sectionKey: DataType.LoanSectionKey.PAYMENT_OPTION
      }
      const requestData = {
        loanId: loanId,
        approvedAmount: approvedAmount,
        totalAmount: approvedAmount + transferAmount
      }
      if (this.loan.loanType === DataType.LoanTypeEnum.MULTIPLE_ADVANCE_LOAN.value) {
        requestData.slaveLoanId = this.slaveLoanId
        updateSectionData.slaveLoanId = this.slaveLoanId
      }

      updateSectionData.featureData = requestData
      OriginationApi.updateSection(updateSectionData, function () {
        popup.popupForSuccess('Save success')
        $this.$eventBus.$emit('saveApprovedAmount', { approvedAmount })
      }, function (result) {
        $this.loanAmountRange = { ...tempLoanAmountRange }
        popup.popupForWarning(result.message)
      })
      $this.hideDialog()
    }
  }
}
</script>

<style scoped>
    .header {
        position: relative;
        z-index: 999;
        top: 0;
        background-color: white;
    }
    .content {
        margin-top: 30px;
    }
    .footer {
        position: relative;
        z-index: 999;
        bottom: 0;
        background-color: white;
    }
</style>
